var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { attrs: { id: "address-confirmation" } }, [
    _c("div", { staticClass: "address-header flex justify-between" }, [
      _c("h5", { staticClass: "address-title lowercase capitalize" }, [
        _vm._v(" " + _vm._s(_vm.title)),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "flex pt-2.5" }, [
        _vm.isPhoenixCustomer && this.$route.name === "Review"
          ? _c(
              "button",
              {
                staticClass: "flex gap-1/4 justify-between w-30",
                on: {
                  click: function ($event) {
                    return _vm.$emit("editBilling")
                  },
                },
              },
              [
                _c("img", {
                  attrs: {
                    src: _vm.checkoutSharedContent.renewalEditIcon.fields.file
                      .url,
                  },
                }),
                _vm._v(" "),
                _c("div", { staticClass: "edit-fields" }, [
                  _vm._v(_vm._s(_vm.editInfoText)),
                ]),
              ]
            )
          : _vm._e(),
      ]),
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "address-details" }, [
      _c("div", [
        _vm._v(
          _vm._s(_vm.address.firstName) + " " + _vm._s(_vm.address.lastName)
        ),
      ]),
      _vm._v(" "),
      _c("div", [_vm._v(_vm._s(_vm.address.email))]),
      _vm._v(" "),
      _c("div", [_vm._v(_vm._s(_vm.address.phone))]),
      _vm._v(" "),
      _c("div", [
        _vm._v(
          _vm._s(_vm.address.address1) + " " + _vm._s(_vm.address.address2)
        ),
      ]),
      _vm._v(" "),
      _c("div", [
        _c("span", [_vm._v(_vm._s(_vm.address.city) + ",")]),
        _vm._v(" "),
        _vm.shouldShowState
          ? _c("span", [_vm._v(_vm._s(_vm.address.state))])
          : _vm._e(),
        _vm._v(" "),
        _c("span", [_vm._v(_vm._s(_vm.address.zip) + ",")]),
        _vm._v(" "),
        _c("span", [_vm._v(_vm._s(_vm.address.country))]),
      ]),
      _vm._v(" "),
      _vm.address.vatId
        ? _c("div", [_vm._v(_vm._s(_vm.address.vatId))])
        : _vm._e(),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }